import React, { Suspense, useState } from 'react';
import { EditorRulesPage } from './inputBlockRules';
import { LinearProgress, Stack } from '@mui/material';
import { Rules } from './rules';

export interface CreatingNewRuleProps {
  isCreatingNewRule: boolean;
  setIsCreatingNewRule: React.Dispatch<React.SetStateAction<boolean>>;
  showAllRules: boolean;
  setShowAllRules: React.Dispatch<React.SetStateAction<boolean>>;
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
}
const RulesPage = () => {
  const [showAllRules, setShowAllRules] = useState<boolean>(false);
  const [isCreatingNewRule, setIsCreatingNewRule] = useState<boolean>(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);

  return (
    <Stack
      direction={'row'}
      spacing={0}
      sx={{
        // Outlet occupies 70% of the page: left = 30% and middle = 40% of the full width
        '& > *:nth-of-type(1)': { flex: '0 0 calc(100% * 3 / 7)', width: 'calc(100% * 3 / 7)' },
        '& > *:nth-of-type(2)': { flex: '0 0 calc(100% * 4 / 7)', width: 'calc(100% * 4 / 7)' }
      }}>
      <Suspense fallback={<LinearProgress />}>
        <Rules
          isCreatingNewRule={isCreatingNewRule}
          setIsCreatingNewRule={setIsCreatingNewRule}
          showAllRules={showAllRules}
          setShowAllRules={setShowAllRules}
          hasUnsavedChanges={hasUnsavedChanges}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
      </Suspense>
      <EditorRulesPage
        isCreatingNewRule={isCreatingNewRule}
        setIsCreatingNewRule={setIsCreatingNewRule}
        showAllRules={showAllRules}
        setShowAllRules={setShowAllRules}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
      />
    </Stack>
  );
};

export default RulesPage;
